var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { ref: "fileArea", staticClass: "file-drag", on: { drop: _vm.dragFile } },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.$t("keystore.dragDrop.text")) + "\n        "
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errMsg,
                expression: "errMsg"
              }
            ],
            staticClass: "msg __err_msg"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.errMsg === "keystore.dragDrop.err2" ||
                    _vm.errMsg === "keystore.dragDrop.err1"
                    ? _vm.$t(_vm.errMsg)
                    : _vm.errMsg
                ) +
                "\n        "
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "hint" }, [
      _vm._v(_vm._s(_vm.$t("keystore.dragDrop.hint")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "__btn __btn_all_in __pointer",
        on: { click: _vm.openFile }
      },
      [
        _c("input", {
          ref: "file",
          staticClass: "open-file",
          attrs: { type: "file", name: "file" }
        }),
        _vm._v(
          "\n        " + _vm._s(_vm.$t("keystore.dragDrop.guide")) + "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "account-list-wrapper" },
      [
        _c("div", { staticClass: "__title" }, [_vm._v("Exited Account")]),
        _vm._v(" "),
        _vm._l(_vm.accountList, function(account, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "__btn_input_active __pointer",
              on: {
                click: function($event) {
                  return _vm.getKeystoreCB(account, "localStorage")
                }
              }
            },
            [
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(account.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "address __ellipsis" }, [
                _vm._v(_vm._s(account.addr))
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }